<div class="containerGeneral"
    [ngClass]="{'mode-edit': edit, 'mode-history': history, 'mode-pending-response': pendingresponse, 'mode-value-blocked': value.isValueLock}">
    <div class="firstLine">
        <div class="key">{{value.routePropertyDefinition.questionTitle | translateH}}</div>

        <value-control-component class="actualValue" [valueCtrl]="valueControl" [(ngModel)]="valueControl.value"
            [readonly]="true" [showhelp]="false">
        </value-control-component>

    </div>
    <div class="description">
        <div [innerHTML]="value.routePropertyDefinition.questionDescription | translateH"></div>
    </div>
    <div class="links">
        <button-link class="history" (linkClick)="history=true"
            *ngIf="!history && !edit && !pendingresponse">{{'GENERAL.HISTORY.CAPTION'
            | translateH}}</button-link>
        <button-link class="edit" (linkClick)="edit=true"
            *ngIf="!history && !edit && !pendingresponse">{{'GENERAL.EDIT.CAPTION' |
            translateH}}</button-link>
        <button-link variant="back" class="line left" (linkClick)="back()"
            *ngIf="(edit || history) && !pendingresponse">{{
            'GENERAL.BACK2.CAPTION' | translateH}}</button-link>
    </div>

    <div class="edit-zone" [formGroup]="rForm">

        <div class="edit-zone-banner">

            <div class="banner-divided-grouped-broken">
                <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
                <div class="texte" *ngIf="value.routePropertyDefinition.blockBannerHelp">
                    <div [innerHTML]="value.routePropertyDefinition.blockBannerHelp | translateH"></div>
                </div>
                <div class="texte" *ngIf="!value.routePropertyDefinition.blockBannerHelp">
                    <div [innerHTML]="'SHARED.ROUTEPROPERTY.BLOCKBANNERHELP.DEFAULT' | translateH"></div>
                </div>
            </div>

        </div>

        <div class="edit-zone-input">
            <div class="question">
                <div [innerHTML]="value.routePropertyDefinition.questionDescription | translateH"></div>
            </div>
            <div class="help" *ngIf="value.routePropertyDefinition.questionHelp">
                <div [innerHTML]="value.routePropertyDefinition.questionHelp | translateH"></div>
            </div>
            <div class="label-value">{{'GENERAL.VALUE.CAPTION' | translateH}}</div>

            <value-control-component class="actualValue" name="valueControl" [valueCtrl]="valueControl"
                [(ngModel)]="valueControl.value" [readonly]="value.isValueLock" [showhelp]="false"
                formControlName="valueControl" (valueChanged)="onValueChanged($event)">
            </value-control-component>

            <shared-savebutton class="botodesar" [showIcon]="true" (save)="save($event)"
                [readonly]="!rForm.dirty && !pendingresponse">
                {{'SHARED.ROUTEPROPERTY.BUTTON.SAVE' | translateH}}
            </shared-savebutton>
        </div>

    </div>

    <div class="history-zone container-table" *ngIf="history">
        <shared-route-item-log-maintenance [uuid]="uuid" [exwork]="exwork" [driver]="driver"
            [routePropertyId]="value.routePropertyId"></shared-route-item-log-maintenance>
    </div>
</div>